/**
 *
 * @param {string} columnKey
 * @param {object} columnsObject, objectInfo keyed by column name
 * @returns {number | false} returns width if its visible, else null,
 */

export const getColumnWidth = (columnKey, columns, level = 0) => {
	if (columns[columnKey]?.checked) {
		const subtractAmount = columnKey === 'task-name' ? 24 * level : 0;
		return columns[columnKey]?.width - subtractAmount;
	}
	return false;
};

export const alignToFlex = align => {
	switch (align) {
		case 'left':
			return 'flex-start';
		case 'center':
			return 'center';
		case 'right':
			return 'flex-end';
	}
};
